import React from "react";
import { connect } from "react-redux";
import { getArticles, getCategories } from "../../actions/log";
import { Container, Card, CardHeader, CardFooter } from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";

import DropdownSelection from "../../components/Commons/DropdownSelection";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/log/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";

const CATEGORIES = [
  {
    id: 1,
    parent_id: null,
    sort: null,
    name: "news",
    display_name: "新聞",
    category_id: 0,
    sub_categories: [
      {
        id: 2,
        parent_id: 1,
        sort: 1,
        name: "daily news",
        display_name: "今日要聞",
        category_id: 0,
      },
      {
        id: 3,
        parent_id: 1,
        sort: 2,
        name: "international news",
        display_name: "國際新聞",
        category_id: 0,
      },
      {
        id: 4,
        parent_id: 1,
        sort: 3,
        name: "oversea Chinese community news",
        display_name: "僑社新聞",
        category_id: 0,
      },
      {
        id: 5,
        parent_id: 1,
        sort: 4,
        name: "local news",
        display_name: "地方新聞",
        category_id: 0,
      },
    ],
  },
  {
    id: 6,
    parent_id: null,
    sort: null,
    name: "tv",
    display_name: "電視",
    category_id: 0,
    sub_categories: [
      {
        id: 7,
        parent_id: 6,
        sort: 1,
        name: "live tv",
        display_name: "直播",
        category_id: 0,
      },
      {
        id: 8,
        parent_id: 6,
        sort: 2,
        name: "news channel",
        display_name: "新聞報導",
        category_id: 0,
      },
      {
        id: 9,
        parent_id: 6,
        sort: 3,
        name: "interview",
        display_name: "專題訪談",
        category_id: 0,
      },
      {
        id: 162,
        parent_id: 6,
        sort: 4,
        name: "video_ads",
        display_name: "影片廣告",
        category_id: 0,
      },
    ],
  },
  {
    id: 10,
    parent_id: null,
    sort: null,
    name: "yellow page",
    display_name: "黃頁",
    category_id: 0,
    sub_categories: [
      {
        id: 11,
        parent_id: 10,
        sort: 1,
        name: "entertainment",
        display_name: "娛樂",
        category_id: 0,
      },
      {
        id: 18,
        parent_id: 10,
        sort: 2,
        name: "legal service",
        display_name: "法律服務",
        category_id: 0,
      },
      {
        id: 24,
        parent_id: 10,
        sort: 3,
        name: "life",
        display_name: "生活日常",
        category_id: 0,
      },
      {
        id: 32,
        parent_id: 10,
        sort: 4,
        name: "real estate",
        display_name: "地產",
        category_id: 0,
      },
      {
        id: 38,
        parent_id: 10,
        sort: 5,
        name: "financial services",
        display_name: "理財保險",
        category_id: 0,
      },
      {
        id: 43,
        parent_id: 10,
        sort: 6,
        name: "cultural organizations",
        display_name: "文化組織",
        category_id: 0,
      },
      {
        id: 49,
        parent_id: 10,
        sort: 7,
        name: "food",
        display_name: "餐飲",
        category_id: 0,
      },
      {
        id: 58,
        parent_id: 10,
        sort: 8,
        name: "health",
        display_name: "醫療健康",
        category_id: 0,
      },
      {
        id: 73,
        parent_id: 10,
        sort: 9,
        name: "outdoors",
        display_name: "汽車出行",
        category_id: 0,
      },
      {
        id: 81,
        parent_id: 10,
        sort: 10,
        name: "education",
        display_name: "教育",
        category_id: 0,
      },
      {
        id: 86,
        parent_id: 10,
        sort: 11,
        name: "businesses",
        display_name: "商業",
        category_id: 0,
      },
    ],
  },
  {
    id: 95,
    parent_id: null,
    sort: null,
    name: "forum",
    display_name: "美南論壇",
    category_id: 0,
    sub_categories: [
      {
        id: 96,
        parent_id: 95,
        sort: 1,
        name: "job hunting",
        display_name: "工作求職",
        category_id: 0,
      },
      {
        id: 97,
        parent_id: 95,
        sort: 2,
        name: "restaurant services",
        display_name: "餐館服務",
        category_id: 0,
      },
      {
        id: 98,
        parent_id: 95,
        sort: 3,
        name: "housekeeping",
        display_name: "家政服務",
        category_id: 0,
      },
      {
        id: 99,
        parent_id: 95,
        sort: 4,
        name: "repair and maintenance",
        display_name: "維修保養",
        category_id: 0,
      },
      {
        id: 100,
        parent_id: 95,
        sort: 5,
        name: "business service",
        display_name: "商家服務",
        category_id: 0,
      },
    ],
  },
  {
    id: 101,
    parent_id: null,
    sort: null,
    name: "events",
    display_name: "活動",
    category_id: 0,
    sub_categories: [
      {
        id: 102,
        parent_id: 101,
        sort: 1,
        name: "spring festival party",
        display_name: "春節遊園會",
        category_id: 0,
      },
      {
        id: 103,
        parent_id: 101,
        sort: 2,
        name: "McDonald's events",
        display_name: "麥當勞教育展",
        category_id: 0,
      },
      {
        id: 104,
        parent_id: 101,
        sort: 3,
        name: "others",
        display_name: "其他",
        category_id: 0,
      },
    ],
  },
  {
    id: 105,
    parent_id: null,
    sort: null,
    name: "business info",
    display_name: "商業",
    category_id: 0,
    sub_categories: [
      {
        id: 106,
        parent_id: 105,
        sort: 1,
        name: "sales info",
        display_name: "促銷活動",
        category_id: 0,
      },
      {
        id: 107,
        parent_id: 105,
        sort: 2,
        name: "merchants info",
        display_name: "商家信息",
        category_id: 0,
      },
    ],
  },
  {
    id: 108,
    parent_id: null,
    sort: null,
    name: "lives",
    display_name: "生活資訊",
    category_id: 0,
    sub_categories: [
      {
        id: 109,
        parent_id: 108,
        sort: 1,
        name: "foodies",
        display_name: "美食",
        category_id: 0,
      },
      {
        id: 110,
        parent_id: 108,
        sort: 2,
        name: "real_estate_channel",
        display_name: "房地產",
        category_id: 0,
      },
      {
        id: 111,
        parent_id: 108,
        sort: 3,
        name: "health",
        display_name: "健康養生",
        category_id: 0,
      },
      {
        id: 112,
        parent_id: 108,
        sort: 4,
        name: "entertainment_channel",
        display_name: "娛樂",
        category_id: 0,
      },
      {
        id: 113,
        parent_id: 108,
        sort: 5,
        name: "traveling",
        display_name: "旅遊",
        category_id: 0,
      },
      {
        id: 159,
        parent_id: 108,
        sort: 6,
        name: "traveling",
        display_name: "體育",
      },
    ],
  },
  {
    id: 114,
    parent_id: null,
    sort: null,
    name: "southern plaza",
    display_name: "美南廣場",
    category_id: 0,
    sub_categories: [
      {
        id: 115,
        parent_id: 114,
        sort: 1,
        name: "southern investments",
        display_name: "美南投資",
        category_id: 0,
      },
      {
        id: 116,
        parent_id: 114,
        sort: 2,
        name: "southern real estate",
        display_name: "美南地產",
        category_id: 0,
      },
    ],
  },
  {
    id: 117,
    parent_id: null,
    sort: null,
    name: "pricing tables",
    display_name: "價目表",
    category_id: 0,
    sub_categories: [
      {
        id: 118,
        parent_id: 117,
        sort: 1,
        name: "southern news",
        display_name: "美南報紙廣告",
        category_id: 0,
      },
      {
        id: 119,
        parent_id: 117,
        sort: 2,
        name: "yellow page and classified ads",
        display_name: "黃頁與分類廣告",
        category_id: 0,
      },
      {
        id: 120,
        parent_id: 117,
        sort: 3,
        name: "travel guide and tvs",
        display_name: "休斯的觀光購物與電視廣告",
        category_id: 0,
      },
      {
        id: 121,
        parent_id: 117,
        sort: 4,
        name: "southern printing",
        display_name: "美南印刷",
        category_id: 0,
      },
    ],
  },
  {
    id: 122,
    parent_id: null,
    sort: null,
    name: "business ads",
    display_name: "商業廣告",
    category_id: 0,
    sub_categories: [],
  },
];

class LogPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      articles: [],
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { category_id } = urlParams;
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams,
      activeCategoryType: activeCategoryType,
    });
    this.getCategories();
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  getCurrentCategory(category_id) {
    var matchRoles = CATEGORIES.filter((value) => {
      return value.id == category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }

  getCategories() {
    this.props.getCategories();
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params,
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType,
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr,
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1,
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  render() {
    const { articles, articlesPagination, getArticlesRequest, categories } =
      this.props.log;
    var activeCategoryType = this.state.activeCategoryType;

    const heads = ["描述", "位置", "用戶", "操作", "時間"];
    const dataAttributes = ["position", "title", "contact", "phone", "email"];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between"></div>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <DropdownSelection
                  Types={categories}
                  activeType={activeCategoryType}
                  filterType={this.filterCat}
                />
              </div>
              <div className="d-flex align-items-center">
                <SearchBar
                  search_string={this.state.title}
                  onSearchInputChange={this.onSearchInputChange}
                />
              </div>
            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            remove={this.removeArticle}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={(page) => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    log: state.log,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getArticles: (params) => dispatch(getArticles(params)),
    getCategories: (params) => dispatch(getCategories(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogPage);
